import React, {ComponentProps, useContext, useState} from "react";

export interface UserType {
  existing: boolean;
  userId: number;
  roles: string[];
  email?: string;
  imageUrl?: string;
  name?: string;
}

export interface FirebaseUserType {
  email: string;
  emailVerified: boolean;
  employerId?: number;
  employerIds: number[];
  existing: boolean;
  lenderId: number;
  name?: string;
  roles: string[];
  uid: string;
  userId: number;
}

interface LoginContextType {
  firebaseUser?: FirebaseUserType;
  setFirebaseUser: (user: FirebaseUserType | undefined) => void;
  loggedInUser?: UserType;
  setLoggedInUser: (user: UserType | undefined) => void;
}

export const LoginContext = React.createContext<LoginContextType>(
  {} as LoginContextType,
);

export const useLoginContext = () => useContext(LoginContext);

export const LoginStateProvider = ({
  children,
}: ComponentProps<"div">): JSX.Element => {
  const [loggedInUser, setLoggedInUser] = useState<UserType>();
  const [firebaseUser, setFirebaseUser] = useState<FirebaseUserType>();

  return (
    <LoginContext.Provider
      value={{
        loggedInUser,
        setLoggedInUser,
        firebaseUser,
        setFirebaseUser,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};
